import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutDirectDepositClassic extends Layout {
}
